var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cplist"},_vm._l((_vm.dataImg),function(item,index){return _c('li',{key:index},[_c('div',[_c('img',{attrs:{"src":item.src}})])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }